import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";

const GrantedUser = React.lazy(() =>
    import('../GrantedUser')
);

const GrantedUserDetail = React.lazy(() =>
    import('../GrantedUserDetail')
);

const grantedUserRoutesRegistry = [
    {
        path: PAGE_URL.GRANTED_USER_PAGE,
        element: <GrantedUser />,
        loading: <Loading />,
        layout: AdminLayout,
    },
    {
        path: `${PAGE_URL.GRANTED_USER_PAGE}/:id`,
        element: <GrantedUserDetail />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default grantedUserRoutesRegistry;
